import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
  ],
});

export const styles = StyleSheet.create({
  page: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',

    paddingHorizontal: 40,
    paddingVertical: 40,
    paddingBottom: 20,
    backgroundColor: '#F5F5F5',
  },

  fullWidthContainer: {
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
  },

  pageTitle: {
    fontSize: 40,
    fontWeight: 700,
    fontFamily: 'Lato',
    textTransform: 'uppercase',
    color: 'black',
  },

  galleryContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 20,
    width: '100%',
  },

  logoWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    backgroundColor: '#ffffff',
    borderRadius: '8px',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
    padding: 10,
    width: 150,
    height: 80,
  },
  logoImage: {
    width: 130,
    objectFit: 'cover',
  },
});
